/* eslint-disable max-lines */
import { AxiosInstance } from "axios";

import {
  BackendMinimalBrainForUser,
  Brain,
  MinimalBrainForUser,
} from "@/lib/context/KnowledgeBaseProvider/types";

import { CreateBrainInput, UpdateBrainInput } from "./types";
import { mapBackendMinimalBrainToMinimalBrain } from "./utils/mapBackendMinimalBrainToMinimalBrain";

export const createBrain = async (
  brain: CreateBrainInput,
  axiosInstance: AxiosInstance,
): Promise<MinimalBrainForUser> => {
  return mapBackendMinimalBrainToMinimalBrain(
    (
      await axiosInstance.post<BackendMinimalBrainForUser>(
        `/knowledge-base`,
        brain,
      )
    ).data,
  );
};

export const getBrain = async (
  brainId: string,
  axiosInstance: AxiosInstance,
): Promise<Brain | undefined> => {
  const brain = (
    await axiosInstance.get<Brain | undefined>(`/knowledge-base/${brainId}`)
  ).data;

  return brain;
};

export const deleteBrain = async (
  brainId: string,
  axiosInstance: AxiosInstance,
): Promise<void> => {
  await axiosInstance.delete(`/knowledge-base/${brainId}`);
};

export const getBrains = async (
  axiosInstance: AxiosInstance,
): Promise<MinimalBrainForUser[]> => {
  const { knowledge_bases } = (
    await axiosInstance.get<{ knowledge_bases: BackendMinimalBrainForUser[] }>(
      `/knowledge-base`,
    )
  ).data;

  const sortedKnowledgeBases = knowledge_bases.sort((a, b) => {
    if (a.brain_type === "model" && b.brain_type !== "model") {
      return -1;
    } else if (a.brain_type !== "model" && b.brain_type === "model") {
      return 1;
    } else if (
      a.brain_type === "model" &&
      b.brain_type === "model" &&
      a.display_name &&
      b.display_name
    ) {
      return a.display_name.localeCompare(b.display_name);
    } else {
      return a.name.localeCompare(b.name);
    }
  });

  return sortedKnowledgeBases.map(mapBackendMinimalBrainToMinimalBrain);
};

export const updateBrain = async (
  brainId: string,
  brain: UpdateBrainInput,
  axiosInstance: AxiosInstance,
): Promise<void> => {
  await axiosInstance.put(`/knowledge-base/${brainId}`, brain);
};
